import {
  IconChartBar as ChartBar,
  IconClock as Clock,
  IconFileCheck as FileCheck,
} from "@tabler/icons-react";

export function HowSection({ t }) {
  const resultIcons = [ChartBar, Clock, FileCheck, ChartBar];

  return (
    <section className="relative overflow-hidden bg-[hsl(var(--background))] py-24 text-[hsl(var(--foreground))] md:py-32 dark:bg-brand-deep dark:text-white">
      <div
        className="absolute inset-0 opacity-[0.05] dark:opacity-[0.08]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, hsl(var(--foreground)) 1px, transparent 1px), radial-gradient(circle at 80% 60%, hsl(var(--foreground)) 1px, transparent 1px)",
          backgroundSize: "48px 48px",
        }}
      />
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_18%,hsl(var(--brand)/0.12),transparent_32%),radial-gradient(circle_at_86%_74%,hsl(var(--brand)/0.1),transparent_34%)] dark:bg-[radial-gradient(circle_at_18%_18%,hsl(var(--brand)/0.22),transparent_32%),radial-gradient(circle_at_86%_74%,hsl(var(--brand)/0.18),transparent_34%)]" />

      <div className="container-x relative">
        <div className="reveal mx-auto max-w-5xl text-center">
          <div
            className="eyebrow mb-4 justify-center"
            style={{ color: "hsl(var(--brand))" }}
          >
            {t.how.eyebrow}
          </div>
          <h2 className="font-display text-[clamp(2rem,4.5vw,3.75rem)] leading-[1.25] font-medium">
            {t.how.titlePrefix}
            <span className="text-brand">{t.how.titleHighlight}</span>
            {t.how.titleSuffix}
          </h2>
          <p className="mx-auto mt-5 max-w-3xl font-sans text-base leading-relaxed text-muted-foreground md:text-lg dark:text-white/68">
            {t.how.subtitle}
          </p>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
          {t.how.steps.map((s, i) => {
            const imageSrc = `${process.env.PUBLIC_URL || ""}/how_step${i + 1}.png`;

            return (
              <div
                key={i}
                className="reveal group relative flex min-h-[36rem] flex-col overflow-visible rounded-2xl border border-white/12 bg-[hsl(var(--brand-deep))] text-white shadow-2xl shadow-[hsl(var(--brand)/0.14)] backdrop-blur-md transition-all hover:-translate-y-1 hover:border-brand/50 hover:bg-[hsl(var(--brand-deep)/0.96)] dark:bg-white/[0.045] dark:shadow-black/20 dark:hover:bg-white/[0.07]"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <div className="relative overflow-hidden rounded-2xl">
                  <div className="relative px-5 pt-6 text-center">
                    <div className="mx-auto grid h-11 w-11 place-items-center rounded-full bg-brand text-sm font-semibold text-white shadow-lg shadow-brand/35">
                      {i + 1}
                    </div>
                    <div className="mt-6 min-h-[3.2rem] font-sans text-base font-bold leading-snug text-white">
                      {s.title}
                    </div>
                  </div>

                  <div className="relative mx-5 mt-4 aspect-[4/5] overflow-hidden rounded-2xl bg-white/[0.04]">
                    <img
                      src={imageSrc}
                      alt={s.title}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[hsl(var(--brand-deep))]/62 via-transparent to-transparent" />
                  </div>

                  <div className="relative mt-auto p-5">
                    <div className="font-sans text-sm font-semibold leading-snug text-white">
                      {s.lead}
                    </div>
                    <div className="mt-2 font-sans text-sm leading-relaxed text-white/68">
                      {s.desc}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="reveal mt-6 grid gap-5 rounded-2xl border border-white/12 bg-[hsl(var(--brand-deep))] p-6 text-white shadow-2xl shadow-[hsl(var(--brand)/0.14)] backdrop-blur md:grid-cols-[1.5fr_repeat(3,1fr)] md:items-center dark:bg-white/[0.045] dark:shadow-none">
          {t.how.result.map((item, i) => {
            const Icon = resultIcons[i] || FileCheck;

            return (
              <div
                key={item.title}
                className="flex items-center gap-4 border-white/10 md:border-l md:pl-6 first:border-l-0 first:pl-0"
              >
                <span className="grid h-12 w-12 shrink-0 place-items-center rounded-2xl bg-brand/18 text-brand">
                  <Icon className="h-6 w-6" />
                </span>
                <div>
                  <div className="font-sans text-base font-semibold leading-snug text-white">
                    {item.title}
                  </div>
                  {item.desc && (
                    <div className="mt-1 font-sans text-sm leading-relaxed text-white/68">
                      {item.desc}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
